import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function RefundPolicy() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>본 정책은 클로젯(이하 "회사")이 운영하는 플랫폼을 통해 구매한 상품의 환불, 교환, 반품과 관련된 사항을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (적용 범위)</h2>
    <p>본 정책은 회사의 플랫폼을 통해 구매한 모든 상품에 적용됩니다. 단, 개별 판매자가 별도로 고지한 환불/교환/반품 정책이 있는 경우 해당 정책이 우선 적용될 수 있습니다.</p>

    <h2>제3조 (청약철회 및 반품)</h2>
    <p><strong>1.</strong> 구매자는 상품 수령 후 7일 이내에 청약철회 또는 반품을 요청할 수 있습니다.</p>
    <p><strong>2.</strong> 청약철회는 다음의 방법으로 신청할 수 있습니다.</p>
    <ul>
      <li>앱 내 마이페이지 > 주문내역 > 취소/교환/반품 신청</li>
      <li>고객센터 이메일: admin@clozet.my</li>
      <li>판매자에게 직접 연락</li>
    </ul>

    <h2>제4조 (반품이 불가능한 경우)</h2>
    <p>다음 각 호의 경우에는 반품이 제한됩니다.</p>
    <ol>
      <li>구매자의 책임 있는 사유로 상품이 멸실 또는 훼손된 경우 (단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</li>
      <li>구매자의 사용 또는 일부 소비로 상품의 가치가 현저히 감소한 경우</li>
      <li>시간이 지나 다시 판매하기 곤란할 정도로 상품의 가치가 현저히 감소한 경우</li>
      <li>복제가 가능한 상품의 포장을 훼손한 경우</li>
      <li>주문 제작 상품의 경우</li>
      <li>신선식품, 언더웨어 등 위생상품의 경우 포장을 개봉한 경우</li>
    </ol>

    <h2>제5조 (교환 절차)</h2>
    <p><strong>1.</strong> 교환은 상품 수령 후 7일 이내에 신청할 수 있습니다.</p>
    <p><strong>2.</strong> 교환 사유가 다음 각 호에 해당하는 경우 교환 배송비는 판매자가 부담합니다.</p>
    <ul>
      <li>상품이 표시·광고 내용과 다르거나 계약 내용과 다르게 이행된 경우</li>
      <li>상품에 하자가 있는 경우</li>
      <li>오배송된 경우</li>
    </ul>
    <p><strong>3.</strong> 단순 변심으로 인한 교환의 경우 왕복 배송비는 구매자가 부담합니다.</p>

    <h2>제6조 (환불 절차)</h2>
    <p><strong>1.</strong> 반품 상품이 판매자에게 도착하고 검수가 완료된 후 환불이 진행됩니다.</p>
    <p><strong>2.</strong> 환불 승인 후 영업일 기준 3~7일 이내에 결제 수단으로 환불됩니다.</p>
    <ul>
      <li>신용카드: 승인 취소 후 카드사 정산일에 따라 환불 (영업일 기준 3~5일)</li>
      <li>계좌이체: 영업일 기준 3일 이내 환불</li>
      <li>간편결제(토스페이): 영업일 기준 3~7일 이내 환불</li>
    </ul>
    <p><strong>3.</strong> 부분 환불의 경우, 환불 금액은 다음과 같이 계산됩니다.</p>
    <ul>
      <li>환불 금액 = 상품 금액 - 배송비 (구매자 귀책 사유인 경우)</li>
    </ul>

    <h2>제7조 (배송비 부담)</h2>
    <p><strong>1.</strong> 판매자 귀책 사유 (상품 하자, 오배송 등)</p>
    <ul>
      <li>왕복 배송비: 판매자 부담</li>
    </ul>

    <p><strong>2.</strong> 구매자 귀책 사유 (단순 변심, 잘못된 주문 등)</p>
    <ul>
      <li>왕복 배송비: 구매자 부담</li>
      <li>반품 배송비: 초기 배송비 + 반송 배송비</li>
    </ul>

    <p><strong>3.</strong> 배송비는 판매자가 설정한 기준에 따라 다를 수 있으며, 상품 상세페이지에서 확인할 수 있습니다.</p>

    <h2>제8조 (환불 지연 시 지연배상금)</h2>
    <p><strong>1.</strong> 회사 또는 판매자가 환불을 지연하는 경우, 지연 기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」에서 정하는 지연이자율에 따라 지연배상금을 지급합니다.</p>
    <p><strong>2.</strong> 지연이자율: 연 15% (2024년 기준)</p>

    <h2>제9조 (취소/교환/반품 신청 방법)</h2>
    <p><strong>1.</strong> 앱 내 신청</p>
    <ul>
      <li>마이페이지 > 주문내역 > 해당 주문 선택 > 취소/교환/반품 신청</li>
      <li>사유 선택 및 상세 내용 입력</li>
      <li>환불 계좌 정보 입력 (필요시)</li>
    </ul>

    <p><strong>2.</strong> 고객센터 문의</p>
    <ul>
      <li>이메일: admin@clozet.my</li>
      <li>필수 정보: 주문번호, 상품명, 취소/교환/반품 사유</li>
    </ul>

    <h2>제10조 (반품 배송 방법)</h2>
    <p><strong>1.</strong> 판매자가 지정한 반품 주소로 상품을 발송합니다.</p>
    <p><strong>2.</strong> 반품 주소는 주문 상세 페이지 또는 판매자 정보에서 확인할 수 있습니다.</p>
    <p><strong>3.</strong> 반품 시 다음 사항에 유의해주시기 바랍니다.</p>
    <ul>
      <li>상품의 택과 라벨을 제거하지 말아주세요</li>
      <li>상품을 착용하거나 세탁하지 말아주세요</li>
      <li>구성품(박스, 사은품 등)을 모두 함께 반송해주세요</li>
      <li>반송 시 송장번호를 반드시 기록해주세요</li>
    </ul>

    <h2>제11조 (특정 상품의 교환/반품 제한)</h2>
    <ol>
      <li>언더웨어, 속옷류: 위생상의 이유로 개봉 후 교환/반품 불가</li>
      <li>맞춤 제작 상품: 제작 시작 후 취소/교환/반품 불가</li>
      <li>할인/프로모션 상품: 개별 상품의 교환/반품 정책에 따름</li>
      <li>신선식품, 화장품: 개봉 후 교환/반품 제한</li>
    </ol>

    <h2>제12조 (교환 불가 시 환불 처리)</h2>
    <p><strong>1.</strong> 교환 요청 상품의 재고가 없는 경우, 구매자의 동의 하에 환불로 처리됩니다.</p>
    <p><strong>2.</strong> 환불은 제6조의 환불 절차에 따라 진행됩니다.</p>

    <h2>제13조 (고객센터 운영)</h2>
    <ol>
      <li>운영시간: 평일 10:00 ~ 18:00 (주말 및 공휴일 휴무)</li>
      <li>이메일: admin@clozet.my</li>
      <li>응대 시간: 영업일 기준 1~2일 이내 답변</li>
    </ol>

    <h2>제14조 (분쟁 해결)</h2>
    <p><strong>1.</strong> 환불/교환/반품과 관련하여 분쟁이 발생한 경우, 회사는 구매자와 판매자 간의 원활한 합의를 위해 중재 역할을 수행합니다.</p>
    <p><strong>2.</strong> 분쟁이 해결되지 않는 경우, 한국소비자원, 공정거래위원회 등 관련 기관에 분쟁조정을 신청할 수 있습니다.</p>

    <h2>제15조 (기타 사항)</h2>
    <p><strong>1.</strong> 본 정책에 명시되지 않은 사항은 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령에 따릅니다.</p>
    <p><strong>2.</strong> 본 정책은 회사의 사정에 따라 변경될 수 있으며, 변경 시 사전에 공지합니다.</p>

    <p><strong>부칙</strong><br>
    본 정책은 2025년 11월 1일부터 시행됩니다.</p>

    <p><strong>회사 정보</strong><br>
    상호: 클로젯<br>
    대표: 김재원<br>
    사업자등록번호: [사업자등록번호 입력 필요]<br>
    통신판매업신고번호: [통신판매업신고번호 입력 필요]<br>
    이메일: admin@clozet.my<br>
    고객센터 운영시간: 평일 10:00 ~ 18:00</p>
  `;

  return (
    <TermsTemplate
      title="환불/교환/반품 정책"
      content={content}
      lastUpdated="2025년 11월 1일"
    />
  );
}
